const MAX_APP_WIDTH = 640

function refreshRem() {
  const viewportWidth = document.documentElement.clientWidth || window.innerWidth || 375
  document.documentElement.style.fontSize = `${Math.min(viewportWidth, MAX_APP_WIDTH) / 10}px`
}

function setBodyFont() {
  if (document.body) {
    document.body.style.fontSize = '16px'
  } else {
    document.addEventListener('DOMContentLoaded', setBodyFont, { once: true })
  }
}

refreshRem()
setBodyFont()
window.addEventListener('resize', refreshRem, { passive: true })
window.addEventListener('orientationchange', refreshRem, { passive: true })
window.addEventListener('pageshow', event => {
  if (event.persisted) refreshRem()
})



// WEBPACK FOOTER //
// ./src/utils/mobileFlexible.js